import { useQuery } from 'react-apollo';

import getAccountCardPreviewFileQuery from '../../../../../../services/cards/graphql/queries/getAccountCardPreviewFile';
import getAccountCardPreviewDownloadFileQuery from '../../../../../../services/cards/graphql/queries/getAccountCardPreviewDownloadFile';

const useCollageDesignerSuccess = ({
  accountCardId,
  prepareDownload = false,
  pollInterval = 2000,
}) => {
  const { data: { accountCard } = {}, stopPolling } = useQuery(
    getAccountCardPreviewFileQuery,
    {
      variables: {
        id: accountCardId,
      },
      pollInterval,
      skip: !accountCardId,
    },
  );

  const { data: { accountCard: accountCardWithDownload } = {} } = useQuery(
    getAccountCardPreviewDownloadFileQuery,
    {
      variables: {
        id: accountCardId,
      },
      skip: !accountCardId || !prepareDownload,
    },
  );

  return {
    previewUrl: accountCard?.front_preview_file_url,
    previewDownloadUrl:
      accountCardWithDownload?.front_preview_file_download_url,
    stopPolling,
  };
};

export default useCollageDesignerSuccess;
